import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";

import ViewGarageLayer from "../../components/garages/ViewGarageLayer";

const ViewGaragePage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb
          routePath="/all-garages"
          routeName="All Garages"
          title="View Garage"
        />

        {/* AddUserLayer */}
        <ViewGarageLayer />
      </MasterLayout>
    </>
  );
};

export default ViewGaragePage;
